import type { InboxRequest } from "../../features/chat/types";

/** Staff role ID — mirrors mobile getRoleId() returning 2 for staff */
export const STAFF_ROLE_ID = 2;
export const INBOX_PAGE = 1;
/** Leave conversation type — mirrors mobile Constants.resolveChat.leave = 1 */
export const LEAVE_CONVERSATION_TYPE = 1;

export const TEAM_INBOX_REQUEST: InboxRequest = {
  archived: false,
  filter: { userTypeMessages: "staff", searchKeyword: "" },
  roleId: STAFF_ROLE_ID,
  page: INBOX_PAGE,
} as const;

export const ARCHIVED_INBOX_REQUEST: InboxRequest = {
  archived: true,
  filter: { userTypeMessages: "staff", searchKeyword: "" },
  roleId: STAFF_ROLE_ID,
  page: INBOX_PAGE,
} as const;

export const CHAT_STRINGS = {
  pinConversationLabel: "Pin Conversation",
  unpinConversationLabel: "Unpin Conversation",
  leaveConversationTitle: "Leave Conversation?",
  leaveConversationLabel: "Leave Conversation",
  leaveConversationDescription:
    "Conversation thread will not be accessible once you leave. Are you sure you want to leave?",
  renameGroupLabel: "Rename Group",
} as const;
